module.exports = __webpack_public_path__ + "img/jywb.432821ba.svg";